<template>
  <b-row no-gutters>
    <b-col class="text-center p-4">
      <div class="rounded bg-lightblack mt-4 mb-4 p-2 m-auto text-center" style="width: 80%; min-height: 100px">
        <h3 class="text-white text-uppercase" style="font-family: Spectral">LES RÉVÉLATIONS DE PYTHAGORE</h3>
        <h5 class="text-white" style="font-family: Spectral">
          Commandez Maintenant Votre Étude Numérologique Et Découvrez Les Secrets Des Nombres Sur Votre Vie
        </h5>

        <img
          class="mt-4"
          src="https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/images%2Fcover-etude-numerologique.png?alt=media&token=462ac024-f638-45c9-9d5f-761a47885a3e"
        />

        <p class="text-white mt-4">
          Commandez maintenant votre Étude Numérologique sur-mesure pour 97€ au lieu de 197€ (pour 72 heures seulement).
        </p>

        <a href="https://membres.academieaime.com/commande-etude/" target="_blank">
          <button class="mt-4 btn btn-primary">Commander Maintenant</button>
        </a>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

export default {
  name: "SalePage",
  components: { BRow, BCol },
};
</script>
